export default "__VITE_ASSET__C0oORK06__"